import { audienceMemberSchema } from "@redotech/redo-marketing-common/audience";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getAudience = {
  name: "getAudience" as const,
  input: z.object({
    search: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .optional(),
    pageContinue: z.string().optional(),
    pageSize: z.number(),
  }),
  output: z.object({
    data: z.array(audienceMemberSchema),
    pageNext: z.string().nullable(),
  }),
};
